import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useMemo } from 'react';
import { Alert } from '@mui/material';
import { useBox } from 'shared/hooks/utils';
import branding from 'shared/app/model/branding';
import { RadioModule, RadioSensor } from 'z3k-config';
import { unpack_validation } from 'z3k-parser/validation/types';
import { findAndChangeLinks } from 'z3k-parser/lib/find-links';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { Z3kDragDropContainer } from '../../utils/drag-drop-drawer/container';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { DragDropDrawer } from '../../utils/drag-drop-drawer/component';
export function RadioModulesList() {
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const { addIdToBlacklist, sendCommand } = useContext(Z3KSettings);
    const configBox = useBox(config);
    const onDeleteModule = useCallback((module) => {
        if (RadioModule.isBuiltinRadioModule433(module)) {
            return;
        }
        //Удаляем все датчики, принадлежащие этому РадиоМодулю
        const sensor_ids_for_delete = [];
        const config_without_sensors = RadioSensor.get.remove(configBox.current, ({ id, related_radiomodule_id }) => {
            //Если принадлежит
            if (module.id === related_radiomodule_id) {
                addIdToBlacklist(id);
                //Отправляем команду на удаление из прибора
                sendCommand(id, 'RemoveObject', null);
                sensor_ids_for_delete.push(id);
                return true;
            }
            return false;
        });
        //Удаляем все ссылки на удалённые датчики
        const config_with_clear_links = sensor_ids_for_delete.reduce((config, id) => findAndChangeLinks(config, id), config_without_sensors);
        //Теперь удаляем сам радиомодуль
        addIdToBlacklist(module.id);
        //Изменяем итоговый конфиг
        replace_config(
        //Чистим ссылки
        findAndChangeLinks(
        //Удаляем из конфига
        RadioModule.get.removeById(config_with_clear_links, module.id), module.id));
        sendCommand(module.id, 'RemoveObject', null);
    }, [replace_config, addIdToBlacklist, sendCommand]);
    const radiomodules_count = useMemo(() => RadioModule.get.all(config).length, [config]);
    const childrenItem = (selected_item_id) => {
        return (_jsx(DragDropDrawer, { z3k_name: "radiomodules", name: RouteNaming[Z3kSecondRoutes.radiomodules], item_url: Z3kSecondRoutes.radiomodules, help_id: "radiomodules", onDelete: onDeleteModule, selected_item_id: selected_item_id, hideAddButton: true }));
    };
    return radiomodules_count > 0 ? (_jsx(Z3kDragDropContainer, { childrenItem: childrenItem })) : (_jsx(Alert, { severity: "info", children: "\u041F\u0440\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u0440\u0430\u0434\u0438\u043E\u043C\u043E\u0434\u0443\u043B\u044F, \u043E\u043D \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u043D\u0430 \u044D\u0442\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435." }));
}
const fields = ['radiomodules'];
RadioModulesList.isError = (validation_result) => {
    return fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
};
RadioModulesList.isWarning = RadioModulesList.isError;
RadioModulesList.isShown = (is_service_view, config, device_spec, is_staff, is_climatic) => {
    if (is_climatic) {
        return false;
    }
    if (branding.show_radiomodule_page_settings_if_need) {
        return (RadioModule.get.where(config, (rm) => !RadioModule.isBuiltinRadioModule433(rm)).length > 0);
    }
    return device_spec.io.has_radiosensors;
};
